























import { Component, Vue } from "vue-property-decorator";
import { IRootStoreState } from "../../store/root";

@Component
export default class DescriptionFilter extends Vue {
  get descriptionSearchText(): string {
    return (this.$store.state as IRootStoreState).coreTableStore!
      .descriptionSearchText;
  }

  set descriptionSearchText(text: string) {
    this.$store.commit("coreTableStore/setDescriptionSearchText", text);
  }
}
